























import { Mixins, Component, Prop, Emit } from 'vue-property-decorator'
import { ElInput } from 'element-ui/types/input'
import { FromValueType } from '@/components/common/form/types'
import TcwFormItemCommon from '@/components/common/form/mixins/TcwFormItemCommon'
import TcwFormItem from '@/components/common/form/TcwFormItem.vue'

@Component({
  components: { TcwFormItem }
})
export default class TcwFormItemText extends Mixins(TcwFormItemCommon) {
  @Prop({ default: 'text' })
  private type!: 'text' | 'textarea'
  @Prop({ default: '' })
  private value!: FromValueType
  @Prop({ default: '' })
  private prefixIcon!: string

  @Emit()
  private input(_value: FromValueType): void {
    //
  }

  public focus(): void {
    (this.$refs.elInput as ElInput).focus()
  }

  public get valueAsString(): string {
    return `${this.value}`
  }
}
